"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableColumnsProperty = exports.resultsTableColumnsPropertyDefinition = void 0;
exports.resultsTableColumnsPropertyDefinition = {
    view: { label: 'Results Table Columns' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'results-table-column-rank',
                'results-table-column-person',
                'results-table-column-main-result',
                'results-table-columns-additional',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'results-table-columns',
};
const isResultsTableColumnsProperty = (prop) => {
    return prop.name === exports.resultsTableColumnsPropertyDefinition.name;
};
exports.isResultsTableColumnsProperty = isResultsTableColumnsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jb2x1bW5zLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVzdWx0cy10YWJsZS1jb2x1bW5zLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQU1hLFFBQUEscUNBQXFDLEdBQUc7SUFDbkQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLHVCQUF1QixFQUFFO0lBQ3hDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUU7Z0JBQ1IsMkJBQTJCO2dCQUMzQiw2QkFBNkI7Z0JBQzdCLGtDQUFrQztnQkFDbEMsa0NBQWtDO2FBQ25DO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsdUJBQXVCO0NBQ0UsQ0FBQTtBQVcxQixNQUFNLDZCQUE2QixHQUFHLENBQUMsSUFBa0IsRUFBdUMsRUFBRTtJQUN2RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssNkNBQXFDLENBQUMsSUFBSSxDQUFBO0FBQ2pFLENBQUMsQ0FBQTtBQUZZLFFBQUEsNkJBQTZCLGlDQUV6QyJ9